import React, {Component} from 'react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts'

class SimpleAreaChart extends React.Component {
    render () {
        const {
            data,
            width = 600,
            height = 400,
            dataKeyName = 'key',
            dataValueName = 'value',
        } = this.props;

        return (
            <BarChart width={width} height={height} data={data}
                      margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey={dataKeyName}/>
                <YAxis/>
                <CartesianGrid strokeDasharray="3 3"/>
                <Tooltip/>
                <Legend />
                <Bar dataKey={dataValueName} fill="#34A4EB" />
            </BarChart>
        );
    }
}

export default SimpleAreaChart;


// WEBPACK FOOTER //
// ./web/src/components/charts/SimpleBarChart.jsx